import Vue from 'vue'
import App from './App.vue'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import i18n from './lang' 
import utils from '@/utils'
import axios from 'axios'
import Cookies from 'js-cookie'
import router from './router'
import store from './store'
import VueMeta from "vue-meta";

Vue.config.productionTip = false
Vue.prototype.$utils = utils
Vue.prototype.$http = axios
Vue.prototype.$url = 'http://www.gbphil.com:5000'
Vue.prototype.$baseURL = 'http://www.gbphil.com:5000'
Vue.prototype.$Cookies = Cookies
Vue.directive('title', {//单个修改标题
  inserted: function (el, binding) {
  document.title = el.dataset.title
  }
})
Vue.use(VueMeta);

router.beforeEach((to, from, next) => {
  if (to.meta.metaInfo){
    store.commit("CAHNGE_META_INFO", to.meta.metaInfo)
  }
  next()
});

new Vue({
  i18n,
  router,
  store,
  metaInfo(){
    return {
        title: this.$store.state.metaInfo.title,
        meta: [
            {
                name: "keywords",
                content: this.$store.state.metaInfo.keywords
            }, {
                name: "description",
                content: this.$store.state.metaInfo.description
            }, {
              name: "og:title",
              content: this.$store.state.metaInfo.ogtitle
            },{
              name: "og:image",
              content: this.$store.state.metaInfo.ogimage
            },{
              name: "og:url",
              content: this.$store.state.metaInfo.ogurl
            }
        ]
    }
  },
  render: h => h(App),
}).$mount('#app')

